module.exports = __webpack_public_path__ + "static/media/ball.2a09c512.mp3";